class HospitalAdmission {
  constructor(admissionWithoutConsent, note, patientId, hospitalId) {
    this.admissionWithoutConsent = admissionWithoutConsent;
    this.note = note;
    this.patientId = patientId;
    this.hospitalId = hospitalId;
  }
}
export default {
  data() {
    return {
      searchTitle: '',
      disabelConfirm: false,
      hospitalTableInformationHeader: [
        {
          text: '',
          value: 'icon',
          align: 'center',
          width: '30px',
          sortable: false,
        },
        {
          text: 'کد آمبولانس',
          value: 'ambulanceCode',
          align: 'center',
          width: '120px',
        },
        { text: 'شکایت اصلی', value: 'cc', align: 'center', width: '200px' },
        {
          text: 'تشخیص اولیه',
          value: 'diagnosis',
          align: 'center',
          width: '150px',
        },
        {
          text: 'نام و نام خانوادگی',
          value: 'fullName',
          align: 'center',
          width: '200px',
        },
        {
          text: 'حدود سن بیمار',
          value: 'age',
          align: 'center',
          width: '150px',
        },
        {
          text: 'بیمارستان',
          value: 'hospital',
          align: 'center',
          width: '120px',
        },
        {
          text: 'عملیات',
          value: 'actions',
          sortable: false,
          align: 'center',
          width: '120px',
        },
      ],
      hospitalMissions: [],
      missionPhoneId: null,
      missionId: null,
      phoneId: null,
      patientId: null,
      allUserHospitals: [],
      admissionModal: false,
      playSoundList: [],
      soundIsPlay: false,
      redFlag: false,
      yellowFlag: false,
      playInterval: null,
    };
  },
  methods: {
    stopMusic: function () {
      this.soundIsPlay = false;
      clearInterval(this.playInterval);
      this.playInterval = null;
    },
    reloadData: function () {
      clearInterval(this.playInterval);
      this.soundIsPlay = false;
      this.redFlag = false;
      this.yellowFlag = false;
      this.playInterval = null;
      this.getAllHospitalAdmissionsActiveFunction();
    },
    itemRowBackground: function (item) {
      if (item.rank == 3) {
        return 'row-back-red';
      } else if (item.rank == 2) {
        return 'row-back-yellow';
      } else {
        return '';
      }
    },
    enableAddEditFunction: function (type, patientId) {
      if (!patientId) {
        this.snackText = 'اطلاعات مددجوثبت نشده است';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (type == 1) {
        this.userId = this.$store.state.userModule.user.id;
        this.getUserHospitalList();
        this.patientId = patientId;
        this.confimType = 'add';
        this.admissionModal = true;
      }
    },
    cancelAdmissionFunction: function () {
      this.hospitalAdmission = new HospitalAdmission(false, '', null, null);
      this.admissionModal = false;
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.title = 'پذیرش مددجو';
        this.$refs.confirm.text = 'از پذیرش مددجو اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      this.$refs.confirm.showConfirmDialog = true;
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addHospitalAdmissionFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    setActionType: function (type, data) {
      if (type == 'ترومایی مرتبط با حمل و نقل') {
        let id = data.id + '-' + data.patientId + '-' + 1;
        this.$router.push({
          name: 'hospitalMissionReportExport',
          params: { id: id },
        });
      } else if (type == 'ترومایی غیرمرتبط با حمل و نقل') {
        let id = data.id + '-' + data.patientId + '-' + 2;
        this.$router.push({
          name: 'hospitalMissionReportExport',
          params: { id: id },
        });
      } else if (type == 'سکته مغزی') {
        let id = data.id + '-' + data.patientId + '-' + 3;
        this.$router.push({
          name: 'hospitalMissionReportExport',
          params: { id: id },
        });
      } else if (type == 'مشکلات قلبی') {
        let id = data.id + '-' + data.patientId + '-' + 4;
        this.$router.push({
          name: 'hospitalMissionReportExport',
          params: { id: id },
        });
      } else {
        let id = data.id + '-' + data.patientId + '-' + 5;
        this.$router.push({
          name: 'hospitalMissionReportExport',
          params: { id: id },
        });
      }
    },
    exportMission: function (missionPhoneId, patientId, type, flag) {
      if (flag == false) {
        if (type[0] == 'ترومایی مرتبط با حمل و نقل') {
          let id = missionPhoneId + '-' + patientId + '-' + 1;
          this.$router.push({
            name: 'hospitalMissionReportExport',
            params: { id: id },
          });
        } else if (type[0] == 'ترومایی غیرمرتبط با حمل و نقل') {
          let id = missionPhoneId + '-' + patientId + '-' + 2;
          this.$router.push({
            name: 'hospitalMissionReportExport',
            params: { id: id },
          });
        } else if (type[0] == 'سکته مغزی') {
          let id = missionPhoneId + '-' + patientId + '-' + 3;
          this.$router.push({
            name: 'hospitalMissionReportExport',
            params: { id: id },
          });
        } else if (type[0] == 'مشکلات قلبی') {
          let id = missionPhoneId + '-' + patientId + '-' + 4;
          this.$router.push({
            name: 'hospitalMissionReportExport',
            params: { id: id },
          });
        } else {
          let id = missionPhoneId + '-' + patientId + '-' + 5;
          this.$router.push({
            name: 'hospitalMissionReportExport',
            params: { id: id },
          });
        }
      } else if (flag == null) {
        let id = missionPhoneId + '-' + 0 + '-' + 6;
        this.$router.push({
          name: 'hospitalMissionReportExport',
          params: { id: id },
        });
      }
    },
  },
};
